import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { AppComponent } from '../app.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-distributors',
  templateUrl: './distributors.component.html',
  styleUrl: './distributors.component.css'
})
export class DistributorsComponent {

  isModalVisible: boolean = false;
  distributorForm: FormGroup;
  loading: boolean = false;
  distributors: any;
  distributorsList: any;
  companies: any;
  providers: any;

  constructor(
    private data: DataserviceService,
    private app: AppComponent,
    private nzNotify: NzNotificationService) {

      this.distributorForm = new FormGroup({
        id: new FormControl(null),
        name: new FormControl(null, [Validators.required]),
        phone: new FormControl('', [Validators.required]),
        companies: new FormControl(null),
        providers: new FormControl(null)
      });
    }

  ngOnInit() {
    this.loading = true;
    this.getDistributors();
    this.getCompanies();
    this.getProviders();
  }

  getDistributors() {
    this.data.getData('distributors')
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.distributors = res?.data || [];
          this.distributorsList = res?.data || [];
        },
        error: (err: any) => {
          console.log('err from getDistributors: ', err)
          this.errorNotification('Failed to get distributors')
        }
      })
  }

  getCompanies() {
    this.data.getData('company')
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data || [];
        },
        error: (err: any) => {
          console.log('err from getCompanies: ', err)
          this.errorNotification('Failed to get companies')
        }
      })
  }

  getProviders() {
    this.data.getData('providers')
      .subscribe({
        next: (res: any) => {
          this.providers = res?.data || [];
        },
        error: (err: any) => {
          console.log('err from getProviders: ', err)
          this.errorNotification('Failed to get providers')
        }
      })
  }

  search(event: any) {
    this.distributorsList = this.distributors.filter((item: any) => {

      const name = item.name.toLowerCase();
      const phone = item.phone.toLowerCase();

      return (
        name.includes(event.target.value.toLowerCase()) ||
        phone.includes(event.target.value.toLowerCase())
      );
    });
  }

  hasPermissions(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  showModal(dist: any) {
    if(this.hasPermissions('manage_distributors')) {
      if(dist) {
        this.distributorForm.patchValue({
          id: dist.id,
          name: dist.name,
          phone: dist.phone,
          companies: this.companies.filter((comp: any) => comp.distributor_id == dist.id).map((comp: any) => comp.id),
          providers: dist.providers
        });
      }
      this.isModalVisible = true;
    }
  }

  addDistributor() {
    let obj = {
      name: this.distributorForm.get('name')?.value,
      phone: this.distributorForm.get('phone')?.value,
      companies: this.distributorForm.get('companies')?.value || [],
      providers: this.distributorForm.get('providers')?.value || []
    }

    this.data.postData(obj, 'distributors/save')
      .subscribe({
        next: (res: any) => {
          this.distributors = res?.data || [];
          this.distributorsList = res?.data || [];
          this.distributorForm.reset()
          this.isModalVisible = false;
          this.loading = false;
          this.successNotification('created')
          this.getCompanies();
        },
        error: (err: any) => {
          this.loading = false;
          this.errorNotification('Failed to add distributor')
        }
      })
  }

  editDistributor() {
    this.data.postData(this.distributorForm.value, 'distributors/save')
      .subscribe({
        next: (res: any) => {
          this.distributors = res?.data || [];
          this.distributorsList = res?.data || [];
          this.distributorForm.reset();
          this.isModalVisible = false;
          this.loading = false;
          this.successNotification('updated')
          this.getCompanies();
        },
        error: (err: any) => {
          this.loading = false;
          this.errorNotification('Failed to update distributor')
        }
      })

  }

  confirmAddEdit() {
    if(this.distributorForm.valid) {
      this.loading = true;
      if(this.distributorForm.get('id')?.value) {
        this.editDistributor()
      }else {
        this.addDistributor()
      }
    }else {
      this.nzNotify.create(
        'warning',
        'Warning!',
        `Please fill out the required fields`,
        { nzPlacement: 'top' }
      );
    }
  }

  cancelAddEdit() {
    this.distributorForm.reset();
    this.isModalVisible = false;
  }

  successNotification(str: string) {
    this.nzNotify.create(
      'success',
      'Success!',
      `Distributor was ${str} successfully!`,
      { nzPlacement: 'top' }
    );
  }

  errorNotification(str: string) {
    this.nzNotify.create(
      'error',
      'Error!',
      str,
      { nzPlacement: 'top' }
    );
  }

}
